import React from 'react';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  LinearProgress,
  Stack,
  Typography,
} from '@mui/material';

export interface ExportProgressState {
  message: string;
  currentPage: number;
  totalPages: number;
}

interface ExportProgressDialogProps {
  open: boolean;
  progress: ExportProgressState;
}

const ExportProgressDialog: React.FC<ExportProgressDialogProps> = ({ open, progress }) => (
  <Dialog
    open={open}
    aria-labelledby="export-progress-dialog"
    PaperProps={{
      sx: {
        minWidth: 300,
        p: 2,
      },
    }}
  >
    <DialogContent>
      <Stack spacing={2} alignItems="center">
        <CircularProgress size={40} />
        <Typography variant="body1" align="center" sx={{ fontWeight: 500 }}>
          {progress.message || 'Preparando exportación...'}
        </Typography>
        {progress.totalPages > 0 && (
          <Box sx={{ width: '100%', mt: 1 }}>
            <LinearProgress
              variant="determinate"
              value={(progress.currentPage / progress.totalPages) * 100}
              sx={{ height: 8, borderRadius: 4 }}
            />
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ mt: 0.5, display: 'block', textAlign: 'center' }}
            >
              {progress.currentPage} de {progress.totalPages} páginas
            </Typography>
          </Box>
        )}
        <Typography variant="body2" color="text.secondary" align="center">
          Por favor, espere mientras se procesan los datos...
        </Typography>
      </Stack>
    </DialogContent>
  </Dialog>
);

export default ExportProgressDialog;
